import { lazy } from 'react';

export const getEnclosureDeviceDetailsPath = '/device-details/enclosure/:sn';
export const getPotscastDeviceDetailsPath = '/device-details/potscast/:sn';
export const getAcsAtaDeviceDetailsPath = '/device-details/ata/:sn';
export const getRouterDeviceDetailsPath = '/device-details/router/:sn';
export const getEquipmentGroupDeviceDetailsPath = '/device-details/equipment-group/:id';

const EnclosureDeviceDetailsCard = lazy(
  () => import('../views/DeviceDetails/EnclosureDeviceDetailsCard/EnclosureDeviceDetailsCard')
);
const PotscastDeviceDetailsCard = lazy(
  () => import('../views/DeviceDetails/PotscastDeviceDetailsCard/PotscastDeviceDetailsCard')
);
const AcsAtaDeviceDetailsCard = lazy(
  () => import('../views/DeviceDetails/AcsAtaDeviceDetailsCard/AcsAtaDeviceDetailsCard')
);
const RouterDeviceDetailsCard = lazy(
  () => import('../views/DeviceDetails/RouterDeviceDetailsCard/RouterDeviceDetailsCard')
);
const EquipmentGroupDeviceDetailsCard = lazy(
  () => import('../views/DeviceDetails/EquipmentGroupDeviceDetailsCard/EquipmentGroupDeviceDetailsCard')
);

export const deviceDetailsRoutes = [
  {
    path: getEnclosureDeviceDetailsPath,
    name: 'Public Enclosure Details',
    component: EnclosureDeviceDetailsCard,
  },
  {
    path: getPotscastDeviceDetailsPath,
    name: 'Public Potscast Details',
    component: PotscastDeviceDetailsCard,
  },
  {
    path: getAcsAtaDeviceDetailsPath,
    name: 'Public ACS ATA Details',
    component: AcsAtaDeviceDetailsCard,
  },
  {
    path: getRouterDeviceDetailsPath,
    name: 'Public Router Details',
    component: RouterDeviceDetailsCard,
  },
  {
    path: getEquipmentGroupDeviceDetailsPath,
    name: 'Public Equipment Group Details',
    component: EquipmentGroupDeviceDetailsCard,
  },
];

export default deviceDetailsRoutes;
